/* LBF MENU CRO — ordre mobile/tablette avec ordre DOM réel pour conserver une navigation accessible. */
(function () {
  'use strict';

  var mq = window.matchMedia('(max-width: 1023px)');

  function directChildByClass(nav, className) {
    for (var i = 0; i < nav.children.length; i += 1) {
      if (nav.children[i].classList.contains(className)) return nav.children[i];
    }
    return null;
  }

  function initMenuCro() {
    var nav = document.getElementById('accessibleNav');
    if (!nav || nav.getAttribute('data-lbf-cro-order') === '1') return;

    var blog = directChildByClass(nav, 'site-nav-blog');
    if (blog) {
      var blogLink = blog.querySelector('a');
      if (blogLink && blogLink.textContent.trim().toLowerCase() === 'blog') blogLink.textContent = 'Blogs';
    }

    var finder = directChildByClass(nav, 'site-nav-trouver-mon-parfum');
    var best = directChildByClass(nav, 'site-nav-meilleures-ventes');
    if (!finder || !best) return;

    var marker = document.createComment('lbf-trouver-mon-parfum-original-position');
    nav.insertBefore(marker, finder);

    function applyOrder() {
      if (mq.matches) {
        nav.insertBefore(finder, best.nextSibling);
      } else if (marker.parentNode === nav) {
        nav.insertBefore(finder, marker.nextSibling);
      }
    }

    applyOrder();

    if (mq.addEventListener) {
      mq.addEventListener('change', applyOrder);
    } else if (mq.addListener) {
      mq.addListener(applyOrder);
    }

    nav.setAttribute('data-lbf-cro-order', '1');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMenuCro, { once: true });
  } else {
    initMenuCro();
  }

  document.addEventListener('shopify:section:load', initMenuCro);
}());
